import { render, staticRenderFns } from "./OrdensTrabalho.vue?vue&type=template&id=e078facc&scoped=true"
import script from "./OrdensTrabalho.vue?vue&type=script&lang=js"
export * from "./OrdensTrabalho.vue?vue&type=script&lang=js"
import style0 from "./OrdensTrabalho.vue?vue&type=style&index=0&id=e078facc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e078facc",
  null
  
)

export default component.exports